import AxiosAPI from '../services/AxiosAPI';
/* global analytics */

export default {
  axiosAPI: new AxiosAPI(),

  isAdBlockerDetected() {
    // If we can find this id, that means our adframe.js file loaded successfully.
    // This indicates that adblocker is not present
    if (document.getElementById('aygHvTNdwLZt')) {
      return false;
    }
    return true;
  },

  track(event, attributes, additionalData) {
    // const gaEvents = ['app_loaded', 'ga_account_created', 'ga_subscription_created', 'ga_subscription_cancelled'];

    const { user } = window.$store.getters;
    if (additionalData === undefined) {
      additionalData = {};
    }
    if (!this.isAdBlockerDetected()) {
      // let context = null;
      // if (gaEvents.indexOf(event) > -1) {
      //   const gaCookie = this.getGACookie();
      //   if (gaCookie) {
      //     context = {
      //       context: {
      //         'Google Analytics': {
      //           clientId: gaCookie,
      //         },
      //       },
      //     };
      //   }
      // }
      this.call('track', event, attributes);
    } else if (user && user.uuid) {
      const params = {
        event_type: event,
        event_params: attributes,
      };
      this.axiosAPI.post('segment/track', params);
    }
  },

  page(pageName, pageTitle = document.title, pageUrl = window.location.href) {
    const { user } = window.$store.getters;
    if (!this.isAdBlockerDetected()) {
      // let context = null;
      // const gaCookie = this.getGACookie();
      // if (gaCookie) {
      //   context = {
      //     context: {
      //       'Google Analytics': {
      //         clientId: gaCookie,
      //       },
      //     },
      //   };
      // }
      this.call('page', pageName, {
        name: pageName,
        title: pageTitle,
        url: pageUrl,
        search: window.location.search,
        referrer: document.referrer,
        path: window.location.pathname,
      });
    } else if (user && user.uuid) {
      const params = {
        page_name: pageName,
        page_title: pageTitle,
        page_url: pageUrl,
      };
      this.axiosAPI.post('segment/page', params);
    }
  },

  identify(userId, attributes) {
    const { user } = window.$store.getters;
    attributes = attributes || {};
    if (user) {
      attributes.email = user.email;
    }
    if (!this.isAdBlockerDetected()) {
      this.call('identify', userId, attributes, {});
    } else if (user && user.uuid) {
      this.axiosAPI.post('segment/identify', attributes);
    }
  },

  call(method, event, attributes, additionalData) {
    if (typeof analytics !== 'undefined') {
      analytics[method](event, attributes, additionalData);
    }
  },

  getGACookie() {
    let GACookie = null;
    let cookies = document.cookie;
    const cookiesMap = {};
    cookies = cookies.split('; ');
    if (cookies.length) {
      cookies.forEach((c) => {
        c = c.split('=');
        const [key, value] = c;
        cookiesMap[key] = value;
      });
    }
    const { _ga } = cookiesMap;
    if (_ga && _ga.length) {
      GACookie = _ga.substr(6);
    }
    return GACookie;
  },
};



// WEBPACK FOOTER //
// ./app/src/shared/analytics.js